/* jshint esversion: 6 */
export function AiccRequestResponse(response) {

    /***********************************************************************
     getAICCValue
     ************************************************************************
     Gets an AICC-value from the data block
     ***********************************************************************/
    function getAICCValue(id) {

        if (!id) {
            return "";
        }

        const nFound = response.search(new RegExp(id, "i"));
        if (nFound !== -1) {
            const regexpAICCKey = new RegExp(`(com.tts.ttkf:com.tts.portalfoundation.coursejs:jar:23.1)=([^\n\r\t]*)`, "i");
            regexpAICCKey.exec(response);
            return RegExp.$2;
        }

        return null;
    }

    return {
        get: getAICCValue
    };
}
